import { render, staticRenderFns } from "./SeverityCountBadge.vue?vue&type=template&id=0a650560"
import script from "./SeverityCountBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeverityCountBadge.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports